import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _includes from 'lodash/includes';

// Components
import Preview from '../../../Customization/Preview/Preview';

// Actions
import { fetchEnvelopeListV2 } from '../../../../../actions/GuestActions';
import { getRecipientAddress } from '../../../../../components/common/form/RecipientAddressing';

// Selectors
import {
  getSize,
  getCustomizations,
  getCustomizationTypeUUIDs,
  getPageEntities,
  getElementEntities,
} from '../../../../selectors/cardProjectSelector';
import { getFontSizeOverrides, getSelectedGuestIds } from '../../../../selectors/Customization';

// Utils
import { mobileScaleFactor, ptToPx, scaledStyle } from '../../../../util';

// Stylesheets
import './ReviewAddressingModal.less';

class ReviewAddressingModal extends Component {
  componentDidMount() {
    const { onFetchGuestList } = this.props;
    onFetchGuestList();
  }

  render() {
    const {
      fontSizeOverrides,
      customization,
      page,
      elements,
      guestGroups,
      selectedGuestIds,
    } = this.props;
    const pageMargin = 60;
    const scaleFactor = mobileScaleFactor(window.innerWidth - pageMargin, ptToPx(page.width));
    const envelopeStyle =
      scaleFactor !== '1' ? scaledStyle(scaleFactor, ptToPx(page.height)) : null;
    // colored envelope background color
    const {
      variation: { option_values: optionValues },
    } = customization;
    const selectedColor = customization.type === 'ENVELOPE' ? `#${optionValues.color}` : '';
    const selectedEnvelopeType =
      customization.type === 'ENVELOPE' ? optionValues['envelope-type'] : '';

    return (
      <div className="review-envelopes-modal">
        <div className="modal-body">
          <div className="addressing-header">
            <span className="header__title">
              <i className="zolaicon zolaicon-preview" /> You are in preview mode
            </span>
          </div>
          <div className="addressing-tiles">
            {selectedGuestIds.map(guestGroupId => {
              const guestGroup = guestGroups[guestGroupId];
              if (!guestGroup) {
                return null;
              }

              const recipientAddress = getRecipientAddress(guestGroup);
              const groupFontSizeOverrides =
                (fontSizeOverrides && fontSizeOverrides[guestGroupId]) || null;

              const customizationValuesWithRecipientAddressing = {
                ...customization.elementsByUUID,
                fontSizeOverrides: groupFontSizeOverrides,
                RECIPIENT_ADDRESS_LINE_1: recipientAddress.line1,
                RECIPIENT_ADDRESS_LINE_2: recipientAddress.line2,
                RECIPIENT_ADDRESS_LINE_3: recipientAddress.line3,
                RECIPIENT_ADDRESS_LINE_4: recipientAddress.line4,
              };

              return (
                <div style={envelopeStyle} key={guestGroupId}>
                  <Preview
                    // key={guestGroupId}
                    customizationUUID={customization.uuid}
                    customizationValues={customizationValuesWithRecipientAddressing}
                    pages={customization.pages}
                    page={page}
                    elements={elements}
                    activeMenuName="envelope"
                    className="preview-wrapper"
                    showText
                    showImgLayer
                    hideBackgroundPreview
                    shape="square"
                    enableEnforceCaps
                    backgroundColor={selectedColor}
                    envelopeType={selectedEnvelopeType}
                  />
                </div>
              );
            })}
          </div>
        </div>
      </div>
    );
  }
}

ReviewAddressingModal.propTypes = {
  customization: PropTypes.shape({}),
  page: PropTypes.shape({}),
  elements: PropTypes.arrayOf(PropTypes.shape({})),
  guestGroups: PropTypes.shape({}),
  selectedGuestIds: PropTypes.arrayOf(PropTypes.number),
  onFetchGuestList: PropTypes.func,
  fontSizeOverrides: PropTypes.shape({}),
};

const mapStateToProps = state => {
  const size = getSize(state);
  const cardType =
    _includes(
      ['SAVE_THE_DATE', 'CHANGE_THE_DATE', 'THANK_YOU', 'HOLIDAY'],
      state.cards.project.type
    ) && size === 'postcard'
      ? state.cards.project.type
      : 'INVITATION_ENVELOPE';
  const customizationTypeToUUID = getCustomizationTypeUUIDs(state);
  const customizations = getCustomizations(state);
  const pageEntities = getPageEntities(state);
  const elementEntities = getElementEntities(state);

  const customizationUUID = customizationTypeToUUID[cardType];
  const customization = customizations[customizationUUID];

  const { pages } = customization;
  const pageUUID = size === 'postcard' ? pages[1] : pages[0];
  const page = pageEntities[pageUUID];
  const elements = page.elements.map(elementUUID => elementEntities[elementUUID]);

  return {
    fontSizeOverrides: getFontSizeOverrides(state),
    customization,
    selectedGuestIds: getSelectedGuestIds(state),
    guestGroups: state.guestList.guests.byId,
    page,
    elements,
  };
};

const mapDispatchToProps = dispatch => ({
  onFetchGuestList: () => dispatch(fetchEnvelopeListV2()),
});

export default connect(mapStateToProps, mapDispatchToProps)(ReviewAddressingModal);



// WEBPACK FOOTER //
// ./src/cards/components/common/modals/ReviewEnvelopeAddressingModal/ReviewAddressingModal.jsx